exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order-receipt-edit-page[data-v-62329616]{padding:24px}.order-receipt-edit-page__card[data-v-62329616]{margin-top:16px}.full-width[data-v-62329616]{width:100%}.order-receipt-edit-page[data-v-62329616] .el-form-item__label{color:#909399;font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62329616","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/OrderReceiptEdit.vue
// module id = 7OJf
// module chunks = 0